import React from 'react'

import Footer from '../../components/Sections/Footer'
import SuperAdminSidebar from '../../components/Elements/Sidebars/SuperAdminSidebar'

const SuperAdmin = () => {
  return (
    <>
  <SuperAdminSidebar/>


<Footer/>
    </>
  
  )
}

export default SuperAdmin